'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _util = require('./util');

var _Controller = require('./Controller');

var _DefaultNotMatchComponent = require('./DefaultNotMatchComponent');

var _DefaultNotMatchComponent2 = _interopRequireDefault(_DefaultNotMatchComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//controller实例化存储，已实例化的controller，从这里取出来，key值是controllerId
var controllerNewObjs = {};
/**
 * 路由控制器React组件，配合Router使用
 *@prop { string } historyType history类型hash、browser、memory，目前还没使用到，保留
 *@state { object } config 路由的一些配置
 *@this { string } pathname 相当与上个页面的pathname，切换页面会变化。
 */
var RouteController = (_temp2 = _class = function (_React$Component) {
  _inherits(RouteController, _React$Component);

  function RouteController() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RouteController);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RouteController.__proto__ || Object.getPrototypeOf(RouteController)).call.apply(_ref, [this].concat(args))), _this), _this.displayName = 'RouteController', _this.state = {}, _this.fristRender = true, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RouteController, [{
    key: 'getPathNameByHistory',

    /**
     * 根据history的值获取pathname
     */
    value: function getPathNameByHistory() {
      var history = this.context.router.history;
      var pathname = history.location.pathname;
      if (pathname === '') {
        pathname = '/';
      }
      return pathname;
    }
    /**
     * 获取页面配置提供给react-router使用，这里是关键的一部。
     *@param {string} pathanme react-router中的history的location.pathname || location.hash，不是浏览器的location
     *@param { object } pluginsConfig 插件配置
     */

  }, {
    key: 'getViewConfig',
    value: function getViewConfig(pathname) {
      var _this2 = this;

      var pluginsConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var params = (0, _util.getParams)(pathname);
      var controllerId = params.controllerId;
      var viewId = params.viewId;
      var funcName = (0, _util.stringAdapter)(viewId) + 'View';
      return _Controller.ControllerConfig.readControllerFile(controllerId).then(function (controller) {
        if (!controller) {
          return false;
        }
        //这里同一个controller只实例化一次
        var controllerObj;
        var hot = _this2.props.hot;

        if (controllerNewObjs[controllerId] && !hot) {
          controllerObj = controllerNewObjs[controllerId];
        } else {
          controllerObj = new controller();
          controllerNewObjs[controllerId] = controllerObj;
        }
        if (!controllerObj[funcName]) {
          return false;
        }
        var config = controllerObj[funcName](params, pluginsConfig);
        return config;
      });
    }
    /**
     * @param { object } pluginsConfig 插件配置
     */

  }, {
    key: 'setConfig',
    value: function setConfig(pluginsConfig) {
      var _this3 = this;

      if (!pluginsConfig) {
        pluginsConfig = this.state.pluginsConfig;
      }
      var pathname = this.getPathNameByHistory();
      return this.getViewConfig(pathname, pluginsConfig).then(function (config) {
        if (!config && pathname === '/') {
          var history = _this3.context.router.history;
          //这里围绕着主页重定向导致的一些问题，做了一些处理。
          //这里需要赋值，不赋值重定向有问题。
          _this3.pathname = '/';
          //防止pathname='/'，重定向时，导致this.state.pluginsConfig为undefined问题。
          _this3.setState({
            pluginsConfig: pluginsConfig
          });
          //这里进行了重定向
          if (Object.prototype.toString.apply(_Controller.ControllerConfig.indexPath) === '[object Function]') {
            history.replace(_Controller.ControllerConfig.indexPath());
          } else {
            history.replace(_Controller.ControllerConfig.indexPath);
          }
          return false;
        }
        var lastConfig;
        if (config && config.component) {
          lastConfig = config;
        } else {
          //如果config为false，为404页面
          lastConfig = {
            component: _Controller.ControllerConfig.NotMatchComponent || _DefaultNotMatchComponent2.default
          };
          document.title = '404 not found';
        }
        _this3.setState({
          config: lastConfig,
          pluginsConfig: pluginsConfig
        });
        return lastConfig;
      });
    }
  }, {
    key: 'shouldComponentUpdate',

    /**
     * 这里的判断基本都是相等了才会返回通过
     * this.hot和this.pathname都是这样，
     * 因为切换页面时，会首先运行一次以前的页面，然后才会切换至新的页面，
     * 这里就是为了解决切换时重复渲染的问题。
     */
    value: function shouldComponentUpdate(nextProps, nextState) {
      //begin--热替换开启处理
      var hot = nextProps.hot;

      if (hot !== this.hot && !this.fristRender) {
        //hot不相等时，不渲染上个未变化的页面
        this.hot = hot;
        return false;
      }
      this.fristRender = false;
      //begin--热替换开启处理
      var pathname = this.getPathNameByHistory();
      //整个页面重载，this.pathname为undefined
      if (this.pathname === undefined) {
        //这里也必须赋值
        this.pathname = pathname;
        return true;
      } else if (this.pathname === pathname) {
        //切换页面时，首先会触发一次componentWillReceiveProps，不需要重渲染
        //然后componentWillReceiveProps相应的触发setConfig
        //setConfig里面触发了setState，改变了state中config的值，这个时候才需要渲染
        //pathname要相等才渲染，因为this.pathname在下面被重新赋值了
        return true;
      } else {
        //页面切换componentWillReceiveProps运行过后，这里也会运行一次，但是不需要重新渲染，
        //然后componentWillReceiveProps里运行的setConfig触发state变化后，
        //这个函数还会运行一遍，然后返回true，render函数就渲染出切换的页面。
        //这里this.pathname赋了新值，跟当前页面的pathname相等了，是否渲染切换后的页面就根据this.pathname来判断了
        this.pathname = pathname;
        return false;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this4 = this;

      var configPromises = _Controller.ControllerConfig.plugins && _Controller.ControllerConfig.plugins.reduce(function (ret, v) {
        var result = v(_this4);
        //如果不是promie对象
        if (!result.then && !result.catch) {
          result = new Promise(function (resolve, reject) {
            resolve(result);
          });
        }
        ret.push(result);
        return ret;
      }, []);
      Promise.all(configPromises || []).then(function (configs) {
        var config = configs.reduce(function (ret, v) {
          if (!v.displayName) {
            console.error('Controller Plugin 必须要设置displayName');
          } else {
            ret[v.displayName] = v;
          }
          return ret;
        }, {});
        _this4.setConfig(config);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = this.getPathNameByHistory();
      if (this.pathname === undefined) {
        //兼容react-router中页面重载，在safari中这里会运行多一次的问题
        //BrowserHistory有bug，safari中会刷新页面不应该触发监听的。
        return;
      }
      var hot = nextProps.hot;
      //是否开启热替换，这里做了热替换处理兼容处理

      if (hot) {
        if (this.hot !== hot) {
          this.setConfig();
        } else {
          //点击链接切换页面时，这函数会触发运行
          //this.pathanme !== pathname
          //console.debug(this.pathname,pathname)
          if (this.pathname !== pathname) {
            this.setConfig();
          }
        }
      } else {
        //点击链接切换页面时，这函数会触发运行
        //this.pathanme !== pathname
        //console.debug(this.pathname,pathname)
        if (this.pathname !== pathname) {
          this.setConfig();
        }
      }
    }
    /**
     * 重新渲染Router下的所有React组件。
     * @return { Promise } 返回promise函数。
     */

  }, {
    key: 'reRender',
    value: function reRender() {
      return this.setConfig();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          config = _state.config,
          pluginsConfig = _state.pluginsConfig;

      if (!config || !pluginsConfig) {
        return false;
      }
      var pathname = this.getPathNameByHistory();
      var layoutProps = {};
      if (config && config.viewConfig) {
        var viewConfig = config.viewConfig;
        layoutProps = {
          reRender: this.reRender.bind(this),
          viewConfig: viewConfig,
          params: viewConfig.params,
          breadcrumbs: viewConfig.breadcrumbs
        };
        layoutProps = _extends({}, layoutProps, pluginsConfig);
        var newViewProps = {
          reRender: this.reRender.bind(this)
        };
        config.component.defaultProps = _extends({}, config.component.defaultProps || {}, newViewProps, pluginsConfig);
      }
      return _react2.default.createElement(
        'span',
        null,
        pathname !== '/' && config && config.LayoutComponent && _react2.default.createElement(
          config.LayoutComponent,
          layoutProps,
          _react2.default.createElement(_reactRouterDom.Route, { path: config.path, component: config.component })
        ),
        pathname !== '/' && config && !config.LayoutComponent && _react2.default.createElement(_reactRouterDom.Route, { path: config.path, component: config.component })
      );
    }
  }]);

  return RouteController;
}(_react2.default.Component), _class.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.shape({
      push: _propTypes2.default.func.isRequired,
      replace: _propTypes2.default.func.isRequired
    }).isRequired,
    staticContext: _propTypes2.default.object
  }).isRequired
}, _temp2);
exports.default = RouteController;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-controller/libs/RouteController.js
// module id = 107
// module chunks = 0